module.exports = __webpack_public_path__ + "img/fairy_light_gas_calculator_1.77c68daf.png";